const regexps = {
  PHONE: /^\+?[-\s0-9]*(\([-\s0-9]+\)[\d\s])?[-\s0-9]*([0-9 ]{1,})$/,
  EMAIL:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-ZÀ-ž\-0-9]+\.)+[a-zA-ZÀ-ž]{2,}))$/,
};

export default regexps;
